module.exports = __webpack_public_path__ + "static/img/logo.5b7c091c.png";